export default {
    pageName: 'History',
    tab: {
        attendance: ' Attendance ',
        quota: 'Quota'
    },
    date: {
        title: 'Date'
    },
    header: {
        detail: 'Detail',
        status: 'Status'
    }
}
